import ajax, { isHttpError, isNetworkError } from "../../authenticationSafeAjax";

export function postEventToServer(event, callback) {
    const request = {
        body: JSON.stringify(event.body),
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        url: "/recorder/api/events/" + event.eventType,
        timeout: 10000
    };

    ajax(request, (statusCode, responseBody) => {
        let response;

        if (isHttpError(statusCode)) {
            response = { errors: ["Unable to record due to an unexpected error."] };
        } else if (isNetworkError(statusCode)) {
            response = { errors: ["Unable to record due to connectivity issues. Please try again."] };
        } else {
            var responseData = JSON.parse(responseBody);
            response = { 
                id: responseData.id,
                disseminatedOn: responseData.disseminatedOn,
                disclosureUri: responseData.disclosureUri, 
                disclaimersUri: responseData.disclaimersUri,
                disclosuresApiUri: responseData.disclosuresApiUri,
                errors: [] 
            };
        }

        callback(response);
    });
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/actions/postEventToServer.js
 **/